import CorporationPositionList from "./CorporationPositionList";

const CorporationPositionSetupPage = () => <CorporationPositionList />;

export default CorporationPositionSetupPage;
